module.exports = __webpack_public_path__ + "img/printing.4053513e.svg";